import { UFOExperience } from '@atlassian/ufo';

/**
 * An extension of the UFOExperience class but it gets fired only once per UI session.
 */
export class UFOExperienceOneTime extends UFOExperience {
	private startInvoked?: boolean;

	start() {
		if (!this.startInvoked) {
			this.startInvoked = true;
			return super.start();
		}

		return Promise.resolve();
	}
}
